export type DraftModalBusyFlags = {
  pageLoading: boolean;
  draftLoading: boolean;
  draftRefetching?: boolean;
  approveLoading: boolean;
  rejectLoading: boolean;
  deleteLoading: boolean;
  lineItemUpdateLoading: boolean;
  lineItemCreateLoading: boolean;
  lineItemDeleteLoading: boolean;
  matchLoading: boolean;
  /** Customer reassignment rematches every line server-side. */
  customerUpdateLoading: boolean;
};

const IDLE: DraftModalBusyFlags = {
  pageLoading: false,
  draftLoading: false,
  draftRefetching: false,
  approveLoading: false,
  rejectLoading: false,
  deleteLoading: false,
  lineItemUpdateLoading: false,
  lineItemCreateLoading: false,
  lineItemDeleteLoading: false,
  matchLoading: false,
  customerUpdateLoading: false,
};

export function isDraftModalBusy(flags: DraftModalBusyFlags): boolean {
  return (
    flags.pageLoading ||
    flags.draftLoading ||
    Boolean(flags.draftRefetching) ||
    flags.approveLoading ||
    flags.rejectLoading ||
    flags.deleteLoading ||
    flags.lineItemUpdateLoading ||
    flags.lineItemCreateLoading ||
    flags.lineItemDeleteLoading ||
    flags.matchLoading ||
    flags.customerUpdateLoading
  );
}

export function idleDraftModalBusyFlags(): DraftModalBusyFlags {
  return { ...IDLE };
}
